export enum LicenseType {
  ACTIVE_WORKER = 'ACTIVE_WORKER',
  ATTACHED_LIGHT_TAG = 'ATTACHED_LIGHT_TAG',
}

export interface LicenseEntitlement {
  type: LicenseType;
  purchasedCount: number;
}

export interface OrganizationLicenseEntitlements {
  organizationId: string;
  entitlements: LicenseEntitlement[];
}

export interface UpdateOrganizationLicenseEntitlementsRequest {
  entitlements: LicenseEntitlement[];
}
